<template>
  <div class="auth-layout">
    <!-- 左侧品牌区：窗口 < 768px 隐藏 -->
    <div class="auth-brand">
      <div class="brand-inner">
        <div class="brand-logo-text">{{ appName }}</div>
        <div class="brand-subtitle">{{ $t('auth.subtitle') }}</div>
      </div>
    </div>

    <!-- 右侧表单区 -->
    <div class="auth-main">
      <div class="auth-lang">
        <LangSwitch />
      </div>
      <div class="auth-card">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import LangSwitch from '@/components/LangSwitch'
export default {
  name: 'AuthLayout',
  components: {
    LangSwitch
  },
  computed: {
    appName() {
      return this.$store.state.appName
    }
  }
}
</script>

<style lang="less" scoped>
.auth-layout {
  display: flex;
  min-height: 100vh;
  background: #ffffff;
}

.auth-brand {
  flex: 1 1 50%;
  background: linear-gradient(135deg, #1e2a4a 0%, #2e4376 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
}

.brand-inner {
  max-width: 420px;
}

.brand-logo-text {
  font-size: 56px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 32px;
  letter-spacing: -0.02em;
}

.brand-slogan {
  font-size: 32px;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 16px;
}

.brand-subtitle {
  font-size: 16px;
  opacity: 0.8;
  line-height: 1.6;
}

.auth-main {
  flex: 1 1 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
}

.auth-lang {
  position: absolute;
  top: 24px;
  right: 32px;
}

.auth-card {
  width: 100%;
  max-width: 440px;
}

/* 响应式：< 768px 隐藏品牌区 */
@media (max-width: 767px) {
  .auth-brand {
    display: none;
  }
  .auth-main {
    flex: 1 1 100%;
    padding: 32px 16px;
  }
}
</style>
